export type ScoreType = 'percentage' | 'outOfTen' | 'iaFit';

export const getScoreColor = (score: number, scoreType: ScoreType = 'outOfTen'): 'success' | 'warning' | 'error' => {
  let normalizedScore: number;
  
  // Normalize all scores to a 0-100 scale for consistent comparison
  switch (scoreType) {
    case 'percentage':
      normalizedScore = score; // Already 0-100
      break;
    case 'outOfTen':
      normalizedScore = score * 10; // Convert 0-10 to 0-100
      break;
    case 'iaFit':
      normalizedScore = score; // IA Fit is already 0-100
      break;
    default:
      normalizedScore = score;
  }

  // Define thresholds (adjust these as needed)
  if (normalizedScore >= 70) return 'success';
  if (normalizedScore >= 40) return 'warning';
  return 'error';
};

export const getScoreLabel = (score: number, scoreType: ScoreType = 'outOfTen'): string => {
  switch (scoreType) {
    case 'percentage':
      return `${score.toFixed(1)}%`;
    case 'outOfTen':
      return `${score.toFixed(1)}/10`;
    case 'iaFit':
      return `${score.toFixed(1)}%`;
    default:
      return score.toString();
  }
};

export const formatCategoryScore = (score: number, maxScore: number): string => {
  return `${score}/${maxScore}`;
};

export const normalizeIaFitScore = (score: number, maxScore: number): number => {
  return (score / maxScore) * 10;
};
